import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            影片分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型浏览，快速找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-50 hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-background-200 hover:border-primary-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}